<template>
  <div
    :id="contentId"
    v-edit:block="contentId"
    class="image-text-block"
    :class="{'in-list': inList}"
  >
    <div
      v-if="image"
      class="image-wrapper"
      :class="isSquareish ? '' : 'nonSquare'"
    >
      <epi-picture
        v-if="image"
        slot="media"
        v-edit="'Image'"
        :use-picture="$root.isSmallViewport ? !isSquareish : true"
        :image="image"
        :fit-dimensions="!isSquareish"
        :sizes="isSquareish ? dimensionsSquare : dimensions"
        :sharpen="80"
        auto-quality="best"
      />
    </div>
    <div class="content-wrapper">
      <h3
        v-if="title || isEditable"
        v-edit="'Title'"
      >
        {{ title }}
      </h3>
      <wysiwyg
        v-if="content || isEditable"
        v-edit="'Content'"
        :content="content"
        class="font-fixed"
      />
      <link-wrapper
        v-if="(url && buttonLabel && inList)"
        class="image-text-block--link"
        :url="url"
        :title="buttonLabel"
      />
      <a
        v-if="(url && buttonLabel && !inList) || isEditable"
        v-edit="'ButtonLabel'"
        :href="url"
        class="button--secondary image-text-block--button button--40"
        v-text="buttonLabel"
      />
    </div>
  </div>
</template>

<script>
import linkWrapper from '@/vue/components/linkWrapper/linkWrapper'

export default {
  name: "ImageTextBlock",
  components: {
    linkWrapper
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    content: {
      type: [Array, String],
      default: () => []
    },
    url: {
      type: String,
      default: ""
    },
    buttonLabel: {
      type: String,
      default: ""
    },
    contentId: {
      type: String,
      default: ""
    },
    inList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dimensionsSquare: {
        small: {
          width: 767
        },
        medium: {
          height: 170,
          width: 170
        },
        large: {
          height: 192,
          width: 192
        }
      },
      dimensions: {
        small: {
          width: 767
        },
        medium: {
          width: 170
        },
        large: {
          width: 192
        }
      }
    }
  },
  computed: {
    isSquareish () {
      // If image is kind of square.
      // We need to check this
      const ratio = this.image.large.width / this.image.large.height
      return (ratio >= 0.5 && ratio <= 1.5)
    }
  }
}
</script>

<style lang="scss">
.image-text-block {
  margin-bottom: 3rem;
  flex-direction: column;
  display: flex;
  padding: 0 2rem;

  @include font(text, 3, "normal");

  @include media-breakpoint-up(md) {
    flex-direction: row;
    padding: 0 3.75rem;

    .epi-background-container {
      padding-bottom: 100% !important;
    }
  }

  @include media-breakpoint-up(lg) {
    padding: 0 5.125rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 0 6.5rem;
  }

  &.in-list {
    margin-top: 2em;
    margin-bottom: 0;
  }

  .image-wrapper {
    margin-bottom: 1rem;

    @include media-breakpoint-up(md) {
      margin-bottom: 0;
      margin-right: 1rem;
    }

    @include media-breakpoint-up(xl) {
      margin-right: 1.5rem;
    }

    .epi-picture {
      text-align: center;

      &,
      & img {
        border-radius: 0.25rem;
      }

      @include media-breakpoint-down(sm) {
        .epi-background-container {
          padding-bottom: 74.598% !important;
        }
      }

      @include media-breakpoint-up(md) {
        text-align: center;
        width: 10.625rem;
      }

      @include media-breakpoint-up(lg) {
        width: 9.5rem;
      }

      @include media-breakpoint-up(xl) {
        width: 12rem;
      }
    }

    &.nonSquare .epi-picture {
      img {
        max-height: 10rem;
      }
    }
  }

  .content-wrapper {
    @include font(text, 3, "normal");

    h3 {
      margin: 0 0 0.5rem;

      @include font(rubrik, 2, "bold");
    }

    .image-text-block--button,
    .image-text-block--link {
      margin-top: 1rem;
    }
  }
}

.dijitReset {
  .image-wrapper {
    flex-grow: 1;

    .image {
      border-radius: 0.25rem;
      width: 100%;
      height: 100%;
      margin-left: auto;
    }
  }
}
</style>
